import { getStaticUrl } from '@/hooks/useCloudflareImage';
import { useTranslation } from '@/hooks/useTranslation';

const BROKER_BRANDS = {
  'sws-test': {
    logoURL: getStaticUrl('partners/sws.png'),
    blurbKey: 'partner.brokerBrand.sws.blurb',
  },
  'avanza-trial': {
    logoURL: getStaticUrl('partners/avanza.png'),
    blurbKey: 'partner.brokerBrand.avanzaTrial.blurb',
  },
  avanza: {
    logoURL: getStaticUrl('partners/avanza.png'),
    blurbKey: 'partner.brokerBrand.avanza.blurb',
  },
} as const;

const isBrokerBrand = (broker: string): broker is keyof typeof BROKER_BRANDS =>
  broker in BROKER_BRANDS;

/**
 * Get broker branding logo + custom blurb for a given broker referrer.
 */
export const useBrokerBrand = (
  // Allow `{}` for the ability to get specific values in autocomplete + allow any string value as
  // an argument. e.g. `avanza` | `avanza-trial` | string
  // eslint-disable-next-line @typescript-eslint/ban-types
  broker: keyof typeof BROKER_BRANDS | ({} & string) | undefined
) => {
  const t = useTranslation();
  if (broker !== undefined && isBrokerBrand(broker)) {
    return {
      logoURL: BROKER_BRANDS[broker].logoURL,
      blurb: t(BROKER_BRANDS[broker].blurbKey),
    };
  }

  return {};
};
